// Clicking the "See Your Logo in 3D" banner in the buy-box jumps straight
// to the size-chart's own gallery slide - it doesn't reimplement slide
// navigation, it just finds that slide's real thumbnail button (rendered
// by product-page-layout-1.liquid with a stable data-target) and clicks
// it, exactly like a shopper would, so it stays compatible with however
// the gallery's own slider-component handles the switch.
(function () {
  document.querySelectorAll('[data-jump-to-size-chart]').forEach(function (banner) {
    banner.addEventListener('click', function () {
      var sectionId = banner.dataset.sectionId;
      var thumbButton = document.querySelector(
        '#Slide-Thumbnails-' + sectionId + '-size-chart button, [data-target="' + sectionId + '-size-chart"] button'
      );
      if (!thumbButton) {
        // Fallback: the thumbnail markup wraps the same product-size-chart
        // snippet used for the real slide - find its own thumb element and
        // walk up to whatever's clickable.
        var thumb = document.querySelector('.product-size-chart-thumb');
        thumbButton = thumb ? thumb.closest('button, a, li, [role="tab"]') : null;
      }
      if (thumbButton) {
        thumbButton.click();
        var gallery = document.querySelector('.product__media-wrapper, .product__media-gallery, [id^="MediaGallery-"]');
        if (gallery && gallery.scrollIntoView) {
          gallery.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  });
})();
